module.exports = __webpack_public_path__ + "img/products-3.931f5707.svg";